import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { Button, CircularProgress, withStyles } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";

import { timeParse, timeFormat } from "d3-time-format";

import api from "../../../services/api";

const formatDate = (time) => timeFormat("%B %d")(timeParse("%s")(time));

const CustomAlert = withStyles((theme) => ({
  root: {
    margin: theme.spacing(1, 0),
  },
  message: {
    flexGrow: 1,
  },
}))(Alert);
const CustomAlertTitle = withStyles((theme) => ({
  root: {
    fontWeight: 600,
  },
}))(AlertTitle);

export default () => {
  const { subscription, paymentMethod } = useSelector((state) => state.stripe);

  if (!subscription)
    return (
      <CustomAlert severity="info" variant="outlined">
        <AlertTitle>Subscription Status</AlertTitle>
        <CircularProgress style={{ margin: "auto" }} size={32} />
      </CustomAlert>
    );
  const { status } = subscription;
  switch (status) {
    case "trialing":
      return (
        <CustomAlert
          severity={paymentMethod ? "success" : "warning"}
          variant="outlined"
          action={
            <PortalButton>{paymentMethod ? "manage" : "Update"}</PortalButton>
          }
        >
          <CustomAlertTitle>Trial</CustomAlertTitle>
          {paymentMethod ? (
            <span>
              Your card will be charged after your trial ends on{" "}
              <strong>{formatDate(subscription.trial_end)}</strong>.
            </span>
          ) : (
            <span>
              Your trial ends{" "}
              <strong>{formatDate(subscription.trial_end)}</strong>. Please
              update your payment method to avoid an interruption to your
              service.
            </span>
          )}
        </CustomAlert>
      );
    case "active":
      return (
        <CustomAlert
          severity="success"
          variant="outlined"
          action={<PortalButton>manage</PortalButton>}
        >
          <CustomAlertTitle>{subscription.plan.nickname}</CustomAlertTitle>
          <span>
            Your plan will automatically renew on{" "}
            <strong>{formatDate(subscription.current_period_end)}</strong>.
            You’ll be charged ${subscription.plan.amount / 100}.
          </span>
        </CustomAlert>
      );
    default:
      return (
        <CustomAlert
          severity="error"
          variant="outlined"
          action={<PortalButton>resolve</PortalButton>}
        >
          <CustomAlertTitle>Issue</CustomAlertTitle>
          <span>
            There's an issue with your subscription. Please resolve in the
            billing portal.
          </span>
        </CustomAlert>
      );
  }
};

const PortalButton = ({ children }) => {
  const [portalUrl, setPortalUrl] = useState(null);
  const subscriptionId = useSelector(
    (state) =>
      state.firebase.profile.subscription &&
      state.firebase.profile.subscription.id
  );

  useEffect(() => {
    const getData = async () => {
      const { url } = await api.getStripePortalLink(subscriptionId);
      setPortalUrl(url);
    };
    if (subscriptionId) getData();
  }, [subscriptionId]);

  return (
    <Button
      variant="outlined"
      href={portalUrl}
      target="_new"
      disabled={!portalUrl}
    >
      {children}
    </Button>
  );
};
